import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';

import { AuthenticationService } from '../../core/services/auth.service';
import { CommonService } from 'src/app/core/services/common.service';
import {AppConfig} from "config";
import { NgxNavigationWithDataComponent } from 'ngx-navigation-with-data';

@Component({
  selector: 'app-topbar',
  templateUrl: './topbar.component.html',
  styleUrls: ['./topbar.component.scss']
})
export class TopbarComponent implements OnInit {
  showFiller:boolean
  projectPath;
  imageBasePath;
  projectName;
  
  notificationItems: Array<{}>;
  languages: Array<{
    id: number,
    flag?: string,
    name: string
  }>;
  selectedLanguage: {
    id: number,
    flag?: string,
    name: string
  };
  UserProfileImage;
  UserName;
  openMobileMenu: boolean;
  HotelId
  @Output() settingsButtonClicked = new EventEmitter();
  @Output() mobileMenuButtonClicked = new EventEmitter();

  constructor(private router: Router, private authService: AuthenticationService,
    private service:CommonService, public navCtrl: NgxNavigationWithDataComponent) { }

  ngOnInit() {
    this.HotelId=localStorage.getItem("HotelId")
    // get the notifications
    this._fetchNotifications();
    
    // get the language
    this._fetchLanguages();

    this.service.httpService({'UserId' : localStorage.getItem("UserId")}, "getAdminUserById").subscribe(response => {
      localStorage.setItem("UserName", response.ResponseData.FullName);
      localStorage.setItem("UserImage", response.ResponseData.UserImage);
      this.UserName = localStorage.getItem("UserName");
      this.UserProfileImage = localStorage.getItem("UserImage") == "null" ? "assets/images/users/avatar.png" : localStorage.getItem("UserImage") ;
    });



    this.selectedLanguage = this.languages[0];
    this.openMobileMenu = false;
    this.imageBasePath = AppConfig.image_base_path;
    this.projectName = AppConfig.app_name;
  }

  /**
   * Change the language
   * @param language language
   */
  changeLanguage(language) {
    this.selectedLanguage = language;
  }

  /**
   * Toggles the right sidebar
   */
  toggleRightSidebar() {
    this.settingsButtonClicked.emit();
  }

  /**
   * Toggle the menu bar when having mobile screen
   */
  toggleMobileMenu(event: any) {
    event.preventDefault();
    
    this.mobileMenuButtonClicked.emit();
    this.showFiller = true
  }

  /**
   * Logout the user
   */
  logout() {
    this.authService.logout();
    this.router.navigate(['/account/login']);
  }


  clearNotification(){
  
    if(this.HotelId==0){
      this.HotelId=""
    }
   else{
      this.HotelId=localStorage.getItem("HotelId")
    }
    var postData = {
      "UserId":localStorage.getItem('UserId'),
      
      "HotelId":this.HotelId
    };
    this.service.httpService(postData, 'removeNotificationlist').subscribe(response => {  
      if (response.IsException == null) { 
        this.notificationItems = response.ResponseData;
      }
      
    });


  }

  /**
   * Fetches the supported languages
   */
  _fetchLanguages() {
    this.languages = [{
      id: 1,
      name: 'English',
      flag: 'assets/images/flags/us.jpg',
    },
    {
      id: 2,
      name: 'German',
      flag: 'assets/images/flags/germany.jpg',
    },
    {
      id: 3,
      name: 'Italian',
      flag: 'assets/images/flags/italy.jpg',
    },
    {
      id: 4,
      name: 'Spanish',
      flag: 'assets/images/flags/spain.jpg',
    },
    {
      id: 5,
      name: 'Russian',
      flag: 'assets/images/flags/russia.jpg',
    }];

    this.selectedLanguage = this.languages[0];
  }

  /**
   * Fetches the notification
   * Note: For now returns the hard coded notifications
   */
  _fetchNotifications() {

    if(this.HotelId==0){
      this.HotelId=""
    }
   else{
      this.HotelId=localStorage.getItem("HotelId")
    }
    var postData = {
      "AdminId":localStorage.getItem('UserId'),
      
      "HotelId":this.HotelId
    };
    this.service.httpService(postData, 'getNotificationList').subscribe(response => {  
      if (response.IsException == null) { 
        this.notificationItems = response.ResponseData;
      }
      
    });

    
  }

  viewAllnotification(){
    this.router.navigate(['./hotels/notification-list'])
  }
}
